<template>
  <svg width="40" height="40" viewBox="0 0 42.22 42.22">
    <path d="M3.52,3.52H38.7V38.7H3.52ZM0,42.22H42.22V0H0Z"/>
    <path d="M22.61,22.5,31,35.08h4.28L25,19.62Z"/>
    <path d="M11.34,20.72V7.1H7.76v18Z"/>
    <path d="M31.31,7.1H26.67L7.76,29.93v5.15h3.58V31.22Z"/>
  </svg>
</template>
